import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ParameterTogglesConfig } from 'src/pages/Allocation/ParameterToggles/ParameterToggles.types';
import { ErrorBoundaryComponentError } from 'src/components/ErrorBoundary/ErrorBoundary.slice';

export interface ParameterTogglesSlice {
  isConfigLoading: boolean;
  isDataLoading: boolean;
  viewDefn: ParameterTogglesConfig | undefined;
}

const initialSlice: ParameterTogglesSlice = {
  isConfigLoading: false,
  isDataLoading: false,
  viewDefn: undefined,
};

const parameterTogglesSliceReducer = createSlice({
  name: 'ParameterToggles',
  initialState: initialSlice,
  reducers: {
    requestParameterTogglesConfig(state) {
      state.isConfigLoading = true;
    },
    receiveParameterTogglesConfig(state, action: PayloadAction<ParameterTogglesConfig>) {
      state.isConfigLoading = false;
      state.viewDefn = action.payload;
    },
    receiveError(_state, _action: PayloadAction<ErrorBoundaryComponentError>) {
      return initialSlice;
    },
    cleanupParameterToggles() {
      return initialSlice;
    },
  },
});

export const {
  requestParameterTogglesConfig,
  receiveParameterTogglesConfig,
  cleanupParameterToggles,
  receiveError,
} = parameterTogglesSliceReducer.actions;
export default parameterTogglesSliceReducer.reducer;
